import {lazy} from 'react'

const ForkygramFollowRequestScreen = lazy(
  () => import('./ForkygramFollowRequestScreen'),
)

export {ForkygramFollowRequestScreen}
